module.exports = __webpack_public_path__ + "img/hygx.f9544523.png";